import { Component, computed, forwardRef, input } from '@angular/core';
import { RepairTaskDetailDto } from '@artemis-software/wr-api';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { isClosedRepairTaskStatus } from '@services/repair-task-status-change.service';

@Component({
  standalone: false,
  selector: 'wr-repair-task-status-select',
  templateUrl: './repair-task-status-select.component.html',
  styleUrls: ['./repair-task-status-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RepairTaskStatusSelectComponent),
      multi: true,
    },
  ],
})
export class RepairTaskStatusSelectComponent extends AbstractFormControl<RepairTaskDetailDto.StatusEnum> {
  readonly readonly = input(false);
  readonly showAll = input(false);
  readonly excludeClosed = input(false);

  readonly enumValues = computed(() => {
    const all = Object.values(RepairTaskDetailDto.StatusEnum);
    if (!this.excludeClosed()) {
      return all;
    }
    const current = this.valueSignal();
    return all.filter(status => !isClosedRepairTaskStatus(status) || status === current);
  });
}
